// @ts-nocheck
import * as React from "react";

const HeartPlus: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -960 960 960">
            <path
                fill="currentColor"
                d="M709.23-300v-120h-120v-40h120v-120h40v120h120v40h-120v120h-40ZM440-173.85l-46.23-41.69Q302.54-299 241.81-359.23q-60.73-60.23-96.54-107.15-35.81-46.93-50.54-85.85Q80-591.15 80-631q0-76.31 51.85-128.04 51.84-51.73 128.15-51.73 52.77 0 99 26.89 46.23 26.88 81 78.42 34.77-51.54 81-78.42 46.23-26.89 99-26.89 72.69 0 122.5 46.89 49.81 46.88 56.12 115.11-14.93-5.46-32.16-8.58-17.23-3.11-36.54-3.11-91.77 0-156.23 63.96T509.23-440q0 41.23 15.23 79.65 15.23 38.43 44 69.12-21.31 19.31-46.81 42.73-25.5 23.42-51.34 47.27L440-173.85Z"
            />
        </svg>
    );
};

export default React.memo(HeartPlus);
